import type { MxpModuleIdV2 } from './mxp365-v2.types';
import type PrismAPI from '@modules/prism-client/types/prism-types';

export const MXP365_V2_EVENTS = {
  OPEN: 'mxp365v2:open',
  CLOSE: 'mxp365v2:close',
} as const;

export type Mxp365V2OpenEventDetail = {
  module: MxpModuleIdV2;
  parameter?: string | null;
  title: string;
  token: string;
  queryParams?: Record<string, string>;
  telemetry?: PrismAPI.TelemetryInstruction[];
};

export type Mxp365V2CloseEventDetail = void;

export type Mxp365V2OpenEvent = CustomEvent<Mxp365V2OpenEventDetail>;
export type Mxp365V2CloseEvent = CustomEvent<Mxp365V2CloseEventDetail>;

export const createMxp365V2OpenEvent = (
  detail: Mxp365V2OpenEventDetail,
): Mxp365V2OpenEvent =>
  new CustomEvent(MXP365_V2_EVENTS.OPEN, {
    detail: {
      module: detail.module,
      parameter: detail.parameter ?? null,
      title: detail.title,
      token: detail.token,
      queryParams: detail.queryParams,
      telemetry: detail.telemetry,
    },
  });
